import { useCallback, useEffect, useState } from 'react';

/**
 * Bridges the Artifacts side-nav item (rendered by Layout) and the artifacts
 * screen (rendered by the router) — they have no shared parent below Layout.
 *
 * Needed because the `Artifacts` module from `@axtria/hqi-genai` owns "list view
 * vs. opened artifact" as its own local state, so clicking the nav while an
 * artifact is open re-navigates to the same path and nothing happens.
 */
// Module-level so every consumer shares one counter.
let resetCount = 0;
let listeners: Array<(_count: number) => void> = [];

export const useArtifactsReset = () => {
  const [artifactsResetCount, setArtifactsResetCount] = useState(resetCount);

  useEffect(() => {
    listeners.push(setArtifactsResetCount);
    return () => {
      listeners = listeners.filter((listener) => listener !== setArtifactsResetCount);
    };
  }, []);

  const triggerArtifactsReset = useCallback(() => {
    resetCount += 1;
    listeners.forEach((listener) => listener(resetCount));
  }, []);

  return { artifactsResetCount, triggerArtifactsReset };
};
